import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Input,
  InputNumber,
  DatePicker,
  Select,
  Upload,
} from "antd";
import { UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import { DataProvider } from "../../DataProvider";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import dayjs from "dayjs";

import RichText from "../ViewClaims/Components/RichText";
import MultipartDataUploader from "./MultipartDataUploader";
import { BASE_URL } from "../../../App/Configs/AppConfigs";
import { localStorageVariableName } from "swfrontend/AppConfigs";
import { ACCEPT_FILE_TYPES, beforeUpload } from "../../Constants";
import { useHistory } from "react-router-dom";
import NewUpdate from "../ViewClaims/Components/NewUpdate";

const NewClaim = ({
  disabled = false,
  contractData = {},
  showDrawer = () => {},
}) => {
  const history = useHistory();

  const disabled_past = (current) => {
    return current && current > dayjs().startOf("day");
  };

  const disable_endDate = (current) => {
    if (!formData?.contract_start_date) {
      openNotification(
        "error",
        "Error",
        "First Select the Contract Start Date"
      );
    }
    return (
      current &&
      current < dayjs(contractData?.contract_start_date).startOf("day")
    );
  };
  const [form] = Form.useForm();
  const dataProvider = new DataProvider();
  const currentDate = dayjs().format("YYYY-MM-DD HH:mm:ss");

  const [formData, setFormData] = useState({
    contractor_name: "",
    contractor_address: "",
    contract_reference: "",
    contract_price: "",
    contract_project: "",
    contract_start_date: currentDate,
    contract_end_date: currentDate,
    details: "",
    support_clauses: "",
    claim_value: "",
    upto_date: currentDate,
    reason: "",
  });
  const [MstLocation, setMstLocation] = useState([]);
  const [MstProgram, setMstProgram] = useState([]);
  const [MstProject, setMstProject] = useState([]);

  const [fileUploaded, setFileUploaded] = useState(false);
  const [locationId, setLocationId] = useState("");
  const getMstLocation = () => {
    dataProvider
      .getDropdownValues("MstLocation")
      .then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            setMstLocation(data["results"]);
          });
        } else {
          response.json().then((responseJson) => {
            openNotification("error", "Error", responseJson["message"]);
          });
        }
      })
      .catch((exception) =>
        openNotification("error", "Error", "Error connecting server")
      );
  };

  const getSupplierData = () => {
    dataProvider
      .getDropdownValues(
        "MstSupplier",
        "contact_person_email=".concat(
          localStorage.getItem(localStorageVariableName.userName)
        )
      )
      .then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            const cont_name = data["results"][0]["display_name"]
              ? data["results"][0]["display_name"]
              : "";
            const cont_addr = data["results"][0]["address"]
              ? data["results"][0]["address"]
              : "";
            const cont_city = data["results"][0]["city"]
              ? data["results"][0]["city"]
              : "";

            form.setFieldsValue({
              contractor_name: data["results"][0]["display_name"],
            });
            form.setFieldsValue({
              contractor_address: `${cont_addr}, ${cont_city}`,
            });

            setFormData({
              ...formData,
              ["contractor_name"]: cont_name,
              ["contractor_address"]: `${cont_addr}, ${cont_city}`,
            });
          });
        } else {
          response.json().then((responseJson) => {
            openNotification("error", "Error", responseJson["message"]);
          });
        }
      })
      .catch((exception) => {
        openNotification("error", "Error", "Error connecting server");
      });
  };

  const getMstProgram = (value) => {
    dataProvider
      .getDropdownValues("MstProgram", "location=".concat(value))
      .then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            setMstProgram(data["results"]);
            form.setFieldsValue({ contract_program: undefined });
            handleChange({ name: "contract_program", value: undefined }, true);

            form.setFieldsValue({ contract_project: undefined });
            handleChange({ name: "contract_project", value: undefined }, true);

            setLocationId(value);
          });
        } else {
          response.json().then((responseJson) => {
            openNotification("error", "Error", responseJson["message"]);
          });
        }
      })
      .catch((exception) =>
        openNotification("error", "Error", "Error connecting server")
      );
  };

  const getMstProject = (value) => {
    dataProvider
      .getDropdownValues("MstProject")
      .then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            setMstProject(
              data["results"].filter(
                (project) =>
                  project?.program?.name === value &&
                  project["program"]["location"]["location_name"] === locationId
              )
            );

            form.setFieldsValue({ contract_project: undefined });
            handleChange({ name: "contract_project", value: undefined }, true);
          });
        } else {
          response.json().then((responseJson) => {
            openNotification("error", "Error", responseJson["message"]);
          });
        }
      })
      .catch((exception) =>
        openNotification("error", "Error", "Error connecting server")
      );
  };

  const DownloadFile = (e, filename) => {
    e.preventDefault(); // Prevent default anchor behavior
    dataProvider
      .downloadFile("contract", filename)
      .then((response) => {
        if (response.status == 200) {
          response.blob().then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const tempLink = document.createElement("a");
            tempLink.href = url;
            tempLink.download = filename.split("/").pop(); // Use the file name from the API
            document.body.appendChild(tempLink);
            tempLink.click();
            tempLink.remove();
            window.URL.revokeObjectURL(url);
          });
        } else {
          response.json().then((responseJson) => {
            openNotification("error", "Error", responseJson["message"]);
          });
        }
      })
      .catch(() => {
        openNotification("error", "Error", "Error fetching the file");
      });
  };

  const handleChange = (e, internal = false) => {
    if (!internal) {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    } else {
      const { name, value } = e;
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleDateChange = (name, dateString) => {
    setFormData({
      ...formData,
      [name]: dateString.includes(" ")
        ? dateString.replace(" ", "T")
        : dateString,
    });
  };

  const handleRichTextChange = (data) => {
    const { name, value } = data;
    setFormData({ ...formData, [name]: value });
  };

  const storeMstProject = (value) => {
    setFormData({ ...formData, ["contract_project"]: value });
  };

  const handleFileUpload = (name, value) => {
    if (value?.file && !beforeUpload(value?.file)) {
      return;
    }
    // Generate a unique name with a counter
    const fileCount = Object.keys(formData).filter((key) =>
      key.startsWith(name)
    ).length;
    const newName = `${name}_${fileCount + 1}`;

    setFormData({ ...formData, [newName]: value.file });
    setFileUploaded(true);
  };

  const validateRichText = () => {
    if (
      formData?.details === "<p></p>" ||
      formData?.details === undefined ||
      formData?.details === null ||
      formData?.details === ""
    ) {
      openNotification("error", "Error", "Please enter details");
      return false;
    } else if (
      formData?.support_clauses === "<p></p>" ||
      formData?.support_clauses === undefined ||
      formData?.support_clauses === null ||
      formData?.support_clauses === ""
    ) {
      openNotification("error", "Error", "Please enter support clauses");
      return false;
    } else if (
      formData?.reason === "<p></p>" ||
      formData?.reason === undefined ||
      formData?.reason === null ||
      formData?.reason === ""
    ) {
      openNotification("error", "Error", "Please enter reason");
      return false;
    } else {
      return true;
    }
  };

  const FormSubmission = async () => {
    if (validateRichText() === false) {
      return;
    }
    if (fileUploaded) {
      const multipart_data = new FormData();
      Object.keys(formData).forEach((key) => {
        multipart_data.append(key, formData?.[key]);
      });
      let api = "/claim/contract/";

      MultipartDataUploader(api, multipart_data, "POST", true, true).then(
        (response) => {
          if (response.status == 201) {
            openNotification(
              "success",
              "Success",
              "Contract Created Successfully"
            );
            history.push("/AllClaim");
          } else {
            openNotification(
              "error",
              "Error",
              "Error Occoured while Contract Creation"
            );
          }
        }
      );
    } else {
      dataProvider
        .newContractCreate(formData)
        .then((response) => {
          if (response.ok) {
            response.json().then((data) => {
              openNotification("success", "Success", data["message"]);
              history.push("/AllClaim");
            });
          } else {
            response.json().then((responseJson) => {
              openNotification("error", "Error", responseJson["message"]);
            });
          }
        })
        .catch((exception) => {
          console.error("Error Occouried While POSTING CONTRACT DATA");
        });
    }
  };

  useEffect(() => {
    getMstLocation();
    getSupplierData();
  }, []);

  useEffect(() => {
    if (Object.keys(contractData)?.length > 0) {
      form.setFieldsValue(contractData);
    }
  }, [contractData]);

  const getUploadList = (name) => {
    return Object.keys(formData)
      .filter((key) => key.startsWith(name))
      .map((key) => ({
        uid: key,
        name: formData[key].name,
        status: "done",
        url: URL.createObjectURL(formData[key]),
      }));
  };

  return (
    <div>
      {!disabled ? (
        <Form
          form={form}
          className="ant-form ant-form-vertical"
          style={{ width: "100%" }}
        >
          <div
            className="row form-box"
            style={{
              padding: "10px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <div>
              <Button
                htmlType="submit"
                type="primary"
                onClick={FormSubmission}
                disabled={disabled}
                hidden={disabled}
              >
                Submit
              </Button>
            </div>
          </div>
        </Form>
      ) : (
        <div
          className="row form-box"
          style={{
            padding: "10px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <div>
            <Button htmlType="button" type="primary" onClick={showDrawer}>
              Show Discussion
            </Button>
          </div>
        </div>
      )}
      {disabled && <NewUpdate contractId={contractData?.id} />}
      <div className="row form-box" style={{ paddingTop: "10px" }}>
        <Form
          form={form}
          className="ant-form ant-form-vertical"
          style={{ width: "100%" }}
        >
          <legend className="form-legend">Contract Details</legend>
          <div className="col-lg-12 col-md-12" style={{ display: "flex" }}>
            <Form.Item
              name={"contractor_name"}
              label="Contractor Name"
              rules={[{ required: true }]}
              style={{ width: "45%", marginLeft: "1%" }}
            >
              <Input
                disabled={true}
                placeholder="Contractor Name"
                name="contractor_name"
                onBlur={handleChange}
              />
            </Form.Item>

            <Form.Item
              name={"contractor_address"}
              label="Contractor Address"
              rules={[{ required: true }]}
              style={{ width: "45%", marginLeft: "5%" }}
            >
              <Input
                disabled={true}
                placeholder="Contractor Address"
                name="contractor_address"
                onBlur={handleChange}
              />
            </Form.Item>
          </div>

          <div className="col-lg-12 col-md-12" style={{ display: "flex" }}>
            <Form.Item
              name={"contract_reference"}
              label="Contract Reference Number"
              rules={[{ required: true }]}
              style={{ width: "45%", marginLeft: "1%" }}
            >
              <Input
                placeholder="contract reference number"
                style={{width: "100%"}}
                name="contract_reference"
                disabled={disabled}
                onBlur={handleChange}
                maxLength={100}
              />
            </Form.Item>

            <Form.Item
              name={"contract_date"}
              label="Contract Date"
              style={{ width: "45%", marginLeft: "5%" }}
              rules={[
                { required: true, message: "Please select Contract Date" },
              ]}
            >
              <DatePicker
                disabled={disabled}
                format={"YYYY-MM-DD"}
                style={{ width: "100%" }}
                onChange={(_, value) =>
                  handleDateChange("contract_date", value)
                }
                disabledDate={disabled_past}
              />
            </Form.Item>
          </div>

          <div className="col-lg-12 col-md-12" style={{ display: "flex" }}>
            <Form.Item
              name={"contract_location"}
              label="Location"
              rules={[{ required: true }]}
              style={{ width: "45%", marginLeft: "1%" }}
            >
              <Select
                disabled={disabled}
                allowClear
                showSearch
                placeholder="Select Location"
                onChange={(value) => getMstProgram(value)}
                options={MstLocation.map((val) => ({
                  value: val.location_id,
                  label: val.location_name,
                }))}
              />
            </Form.Item>

            <Form.Item
              name={"contract_program"}
              label="Program"
              rules={[{ required: true }]}
              style={{ width: "45%", marginLeft: "5%" }}
            >
              <Select
                allowClear
                showSearch
                placeholder="Select Program"
                disabled={disabled}
                onChange={(value) => getMstProject(value)}
              >
                {MstProgram.map((val) => (
                  <option key={val.program_name} value={val.id}>
                    {val.program_name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </div>

          <div className="col-lg-12 col-md-12" style={{ display: "flex" }}>
            <Form.Item
              name={"contract_project"}
              label="Project"
              rules={[{ required: true }]}
              style={{ width: "45%", marginLeft: "1%" }}
            >
              <Select
                allowClear
                showSearch
                placeholder="Select Project"
                disabled={disabled}
                onChange={(value) => storeMstProject(value)}
                options={MstProject.map((val) => ({
                  value: val.project_id,
                  label: val.project_name,
                }))}
              />
            </Form.Item>

            <Form.Item
              name={"contract_price"}
              label="Contractor Price"
              rules={[{ required: true }]}
              style={{ width: "45%", marginLeft: "5%" }}
            >
              <InputNumber
                step={1}
                max={21474836471}
                parser={value => value.replace(/\D/g, '')}
                name="contract_price"
                disabled={disabled}
                onBlur={handleChange}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </div>

          <div className="col-lg-12 col-md-12" style={{ display: "flex" }}>
            <Form.Item
              name={"contract_start_date"}
              label="Contract Start Date"
              rules={[{ required: true }]}
              style={{ width: "45%", marginLeft: "1%" }}
            >
              <DatePicker
                disabled={disabled}
                format={"YYYY-MM-DD"}
                style={{ width: "100%" }}
                onChange={(_, value) =>
                  handleDateChange("contract_start_date", value)
                }
                disabledDate={disabled_past}
              />
            </Form.Item>

            <Form.Item
              name={"contract_end_date"}
              label="Contract End Date"
              rules={[{ required: true }]}
              style={{ width: "45%", marginLeft: "5%" }}
            >
              <DatePicker
                disabled={disabled}
                format={"YYYY-MM-DD"}
                picker="day"
                style={{ width: "100%" }}
                onChange={(_, value) =>
                  handleDateChange("contract_end_date", value)
                }
                disabledDate={disable_endDate}
              />
            </Form.Item>
          </div>
        </Form>
      </div>

      <Form
        form={form}
        className="ant-form ant-form-vertical"
        style={{ width: "100%" }}
      >
        <div className="row form-box" style={{ paddingTop: "10px" }}>
          <legend className="form-legend">Claim Details</legend>
          <div className="col-lg-6 col-md-12" style={{ display: "flex" }}>
            <Form.Item
              name={"contractor_letter_number"}
              label="Contractor Letter Number"
              rules={[{ required: false }]}
              style={{ width: "90%", marginLeft: "2%" }}
            >
              <Input
                placeholder="Enter Letter Number"
                style={{ width: "100%" }}
                name="contractor_letter_number"
                disabled={disabled}
                onBlur={handleChange}
                            maxLength={100}
              />
            </Form.Item>
          </div>
          <div className="col-lg-6 col-md-12" style={{ display: "flex" }}>
            <Form.Item
              name="contractor_file"
              label="Contractor Letter"
              rules={[
                {
                  required: false,
                },
              ]}
              style={{ width: "90%", marginLeft: "1%" }}
            >
              {contractData?.contractor_file ? (
                contractData?.contractor_file?.map((item) => (
                  <a
                    href={`${BASE_URL.replace("/api", "")}${item}`}
                    download={item.split("/").pop()} // Triggers a download when clicked
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e, _) =>
                      DownloadFile(
                        e,
                        `contractor_file=${item.replace("/", "")}`
                      )
                    }
                  >
                    <DownloadOutlined />
                    {item.split("/").pop()}
                    <br />
                  </a>
                ))
              ) : (
                <Upload
                  onChange={(info) => handleFileUpload("contractor_file", info)}
                  showUploadList={{
                    showRemoveIcon: true,
                    items: getUploadList("contractor_file"),
                  }}
                  beforeUpload={(file) => {
                    // Handle file upload manually
                    beforeUpload("contractor_file", { file });
                    // Prevent automatic form submission
                    return false;
                  }}
                  // beforeUpload={beforeUpload}
                  maxCount={1}
                  accept={ACCEPT_FILE_TYPES}
                >
                  <Button icon={<UploadOutlined />}>Select File</Button>
                </Upload>
              )}
            </Form.Item>
          </div>

          <div className="col-lg-12 col-md-12">
            <Form.Item
              name={"details"}
              style={{ width: "95%", marginLeft: "1%" }}
            >
              <RichText
                name="details"
                value={contractData?.details ? contractData?.details : ""}
                disabled={disabled ? true : false}
                onChange={handleRichTextChange}
              />
              {contractData?.details_file ? (
                contractData?.details_file?.map((item) => (
                  <a
                    href={`${BASE_URL.replace("/api", "")}${item}`}
                    download={item.split("/").pop()} // Triggers a download when clicked
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e, _) =>
                      DownloadFile(e, `details_file=${item.replace("/", "")}&request_id=${contractData?.id}`)
                    }
                  >
                    <DownloadOutlined />
                    {item.split("/").pop()}
                    <br />
                  </a>
                ))
              ) : (
                <Upload
                  disabled={disabled}
                  onChange={(info) => handleFileUpload("details_file", info)}
                  showUploadList={{
                    showRemoveIcon: true,
                    items: getUploadList("details_file"),
                  }}
                  beforeUpload={() => false}
                  maxCount={5}
                  accept={ACCEPT_FILE_TYPES}
                >
                  <Button icon={<UploadOutlined />}>Select File</Button>
                </Upload>
              )}
            </Form.Item>
          </div>
        </div>

        <div className="row form-box" style={{ paddingTop: "10px" }}>
          <legend className="form-legend">Support Clause</legend>

          <div className="col-lg-12 col-md-12">
            <Form.Item
              name={"support_clauses"}
              style={{ width: "95%", marginLeft: "1%" }}
            >
              <RichText
                name="support_clauses"
                value={
                  contractData?.support_clauses
                    ? contractData?.support_clauses
                    : ""
                }
                disabled={disabled ? true : false}
                onChange={handleRichTextChange}
              />
              {contractData?.support_clauses_file ? (
                contractData?.support_clauses_file?.map((item) => (
                  <a
                    href={`${BASE_URL.replace("/api", "")}${item}`}
                    download={item.split("/").pop()} // Triggers a download when clicked
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e, _) =>
                      DownloadFile(
                        e,
                        `support_clauses_file=${item.replace("/", "")}&request_id=${contractData?.id}`
                      )
                    }
                  >
                    <DownloadOutlined />
                    {item.split("/").pop()}
                    <br />
                  </a>
                ))
              ) : (
                <Upload
                  disabled={disabled}
                  onChange={(info) =>
                    handleFileUpload("support_clauses_file", info)
                  }
                  showUploadList={{
                    showRemoveIcon: true,
                    items: getUploadList("support_clauses_file"),
                  }}
                  beforeUpload={() => false}
                  maxCount={5}
                  accept={ACCEPT_FILE_TYPES}
                >
                  <Button icon={<UploadOutlined />}>Select File</Button>
                </Upload>
              )}
            </Form.Item>
          </div>
        </div>

        <div className="row form-box" style={{ paddingTop: "10px" }}>
          <legend className="form-legend">Claim Value and Date</legend>
          <div className="col-lg-12 col-md-12" style={{ display: "flex" }}>
            <Form.Item
              name={"claim_value"}
              label="Claim Amount"
              rules={[{ required: true }]}
              style={{ width: "45%", marginLeft: "1%" }}
            >
              <InputNumber
                step={1}
                max={21474836471}
                parser={value => value.replace(/\D/g, '')}
                placeholder="Enter Claim Amount"
                style={{ width: "100%" }}
                name="claim_value"
                disabled={disabled}
                onBlur={handleChange}
                
              />
            </Form.Item>

            <Form.Item
              name={"upto_date"}
              label="Claim Submission Date"
              rules={[{ required: true }]}
              style={{ width: "45%", marginLeft: "5%" }}
            >
              <DatePicker
                disabled={disabled}
                format={"YYYY-MM-DD"}
                picker="day"
                style={{ width: "100%" }}
                onChange={(_, value) => handleDateChange("upto_date", value)}
              />
            </Form.Item>
          </div>
        </div>

        <div className="row form-box" style={{ paddingTop: "10px" }}>
          <legend className="form-legend">Claim Reason</legend>
          <div className="col-lg-12 col-md-12">
            <Form.Item
              name={"reason"}
              style={{ width: "95%", marginLeft: "1%" }}
            >
              <RichText
                name="reason"
                value={contractData?.reason ? contractData?.reason : ""}
                disabled={disabled ? true : false}
                onChange={handleRichTextChange}
              />

              {contractData?.reason_file ? (
                contractData?.reason_file?.map((item) => (
                  <a
                    href={`${BASE_URL.replace("/api", "")}${item}`}
                    download={item.split("/").pop()} // Triggers a download when clicked
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e, _) =>
                      DownloadFile(e, `reason_file=${item.replace("/", "")}&request_id=${contractData?.id}`)
                    }
                  >
                    <DownloadOutlined />
                    {item.split("/").pop()}
                    <br />
                  </a>
                ))
              ) : (
                <Upload
                  disabled={disabled}
                  onChange={(info) => handleFileUpload("reason_file", info)}
                  showUploadList={
                    formData?.reason_file ? formData?.reason_file : false
                  }
                  beforeUpload={() => false}
                  maxCount={5}
                  accept={ACCEPT_FILE_TYPES}
                >
                  <Button icon={<UploadOutlined />}>Select File</Button>
                </Upload>
              )}
            </Form.Item>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default NewClaim;
